import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 25",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m2.727 10.05v2.666h1.403c-.015-.221-.038-.441-.038-.667 0-5.523 5.19-10 11.59-10 1.205 0 2.364.16 3.455.452a5.475 5.475 0 0 1 4.045-1.785v3.716c1.542 1.132 2.728 2.606 3.417 4.284h3.401v4c0 .737-.61 1.333-1.364 1.333h-1.596c-.527 2.235-1.92 4.195-3.858 5.618v5.05h-4.092v-3.109a13.268 13.268 0 0 1 -3.41.441c-1.186 0-2.33-.154-3.408-.44v3.107h-4.09v-5.05c-1.543-1.131-2.729-2.605-3.417-4.283h-2.038c-1.504 0-2.727-1.196-2.727-2.667 0-1.47 1.223-2.667 2.727-2.667",
  fill: "#111224"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }